import { render, staticRenderFns } from "./PaymentDrawer.vue?vue&type=template&id=52bb9899&scoped=true"
import script from "./PaymentDrawer.vue?vue&type=script&lang=ts"
export * from "./PaymentDrawer.vue?vue&type=script&lang=ts"
import style0 from "./PaymentDrawer.vue?vue&type=style&index=0&id=52bb9899&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bb9899",
  null
  
)

export default component.exports